import React from "react";
import PreviewMessageArabicNotificationCenter from "./PreviewMessageArabicNotificationCenter";
import PreviewMessageEnglishNotificationCenter from "./PreviewMessageEnglishNotificationCenter";
import clsx from "clsx";
import PreviewMessageEnglishPushNotification from "./PreviewMessageEnglishPushNotification";
import PreviewMessageArabicPushNotification from "./PreviewMessageArabicPushNotification";

const PreviewNotification = ({
  activeEnglishPreview,
  activeArabicPreview,
  setActiveEnglishPreview,
  setActiveArabicPreview,
  englishValues,
  arabicValues,
}) => {
  return (
    <div className="flex flex-wrap items-start justify-between mt-5 gap-y-5">
      <div className="w-full lg:w-[49%] self-stretch pt-3 pb-5 rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-300 inline-flex flex-col justify-center items-center gap-5">
        <div className="justify-center text-zinc-800 text-base font-medium font-['Montserrat']">
          Message in English
        </div>

        <div className="w-full">
          <div className="self-stretch h-px bg-slate-300" />
        </div>
        <div className="self-stretch rounded-xl flex flex-col justify-center items-end gap-8">
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch flex flex-col justify-start items-center">
              <div className="flex items-center w-full">
                <div
                  onClick={() => setActiveEnglishPreview("notification-center")}
                  className={clsx(
                    "w-1/2 text-xs font-semibold cursor-pointer text-center pb-2",
                    activeEnglishPreview === "notification-center"
                      ? "text-sky-900 border-b-[1px] border-sky-900"
                      : "text-neutral-400"
                  )}
                >
                  Notification Center
                </div>
                <div
                  onClick={() => setActiveEnglishPreview("push-notification")}
                  className={clsx(
                    "w-1/2 text-xs font-semibold cursor-pointer text-center pb-2",
                    activeEnglishPreview === "push-notification"
                      ? "text-sky-900 border-b-[1px] border-sky-900"
                      : "text-neutral-400"
                  )}
                >
                  Push Notification
                </div>
              </div>
              <div className="w-full flex flex-col justify-start items-end">
                {/* <div className="w-64 h-px bg-sky-900" /> */}
                <div className="w-full h-px bg-slate-300" />
              </div>
            </div>
          </div>
          {activeEnglishPreview === "notification-center" && (
            <PreviewMessageEnglishNotificationCenter
              englishValues={englishValues}
            />
          )}
          {activeEnglishPreview === "push-notification" && (
            <PreviewMessageEnglishPushNotification
              englishValues={englishValues}
            />
          )}
        </div>
      </div>

      <div className="w-full lg:w-[49%] self-stretch pt-3 pb-5 rounded-xl outline outline-1 outline-offset-[-1px] outline-slate-300 inline-flex flex-col justify-center items-center gap-5">
        <div className="justify-center text-zinc-800 text-base font-medium font-['Montserrat']">
          Message in Arabic
        </div>

        <div className="w-full">
          <div className="self-stretch h-px bg-slate-300" />
        </div>
        <div className="self-stretch rounded-xl flex flex-col justify-center items-end gap-8">
          <div className="self-stretch flex flex-col justify-start items-start">
            <div className="self-stretch flex flex-col justify-start items-center">
              <div className="flex items-center w-full">
                <div
                  onClick={() => setActiveArabicPreview("notification-center")}
                  className={clsx(
                    "w-1/2 text-xs font-semibold cursor-pointer text-center pb-2",
                    activeArabicPreview === "notification-center"
                      ? "text-sky-900 border-b-[1px] border-sky-900"
                      : "text-neutral-400"
                  )}
                >
                  Notification Center
                </div>
                <div
                  onClick={() => setActiveArabicPreview("push-notification")}
                  className={clsx(
                    "w-1/2 text-xs font-semibold cursor-pointer text-center pb-2",
                    activeArabicPreview === "push-notification"
                      ? "text-sky-900 border-b-[1px] border-sky-900"
                      : "text-neutral-400"
                  )}
                >
                  Push Notification
                </div>
              </div>
              <div className="w-full flex flex-col justify-start items-end">
                {/* <div className="w-64 h-px bg-sky-900" /> */}
                <div className="w-full h-px bg-slate-300" />
              </div>
            </div>
          </div>
          {activeArabicPreview === "notification-center" && (
            <PreviewMessageArabicNotificationCenter
              arabicValues={arabicValues}
            />
          )}
          {activeArabicPreview === "push-notification" && (
            <PreviewMessageArabicPushNotification arabicValues={arabicValues} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewNotification;
